import script from "./CopyMapLink.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyMapLink.vue?vue&type=script&setup=true&lang=js"

import "./CopyMapLink.vue?vue&type=style&index=0&id=1685100e&lang=css"

const __exports__ = script;

export default __exports__